module.exports = __webpack_public_path__ + "media/images/icons/telstra_logo-fad62ea3bae30dcc72f9a812b831d08b.png";